module.exports = __webpack_public_path__ + "static/media/Phone.fe63748d.svg";